import React, { useState, useEffect } from "react";
import "./Clock.css";

export default function Clock() {
  let [time, setTime] = useState(new Date());

  useEffect(() => {
    let timerId = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(timerId);
  }, []);

  function formatTime(date) {
    let hours = date.getHours().toString().padStart(2, "0");
    let minutes = date.getMinutes().toString().padStart(2, "0");
    let seconds = date.getSeconds().toString().padStart(2, "0");
    return `${hours}:${minutes}:${seconds}`;
  }

  function formatDate(date) {
    return date.toLocaleDateString("it-IT", {
      weekday: "long",
      day: "numeric",
      month: "long",
    });
  }

  return (
    <div className="Clock">
      <p className="Clock-time">{formatTime(time)}</p>
      <p className="Clock-date">{formatDate(time)}</p>
    </div>
  );
}
